export default __webpack_public_path__ + "static/media/mobile_contribute.4d9a752e.mp4";